import res from 'res'; //Detects dpi and resolution
import Scrollbar from './components/scrollbar.js';

var breakpoints = {
  lg: 1600,
  md: 1199,
  sm: 1024,
  xs: 767
};

function detect() {
    let isDesktopHD, isDesktop, isTablet, isMobile;
    let brpDesktop = breakpoints.md;
    let brpTablet = breakpoints.sm;
    let brpMobile = breakpoints.xs;
    let windowWidth = $('body').width();

    if(Scrollbar.isActive()){
      windowWidth = $('body').width() + Scrollbar.getWidth();
    }
    
    let mediaObj = {
      'isDesktopHD': windowWidth > brpDesktop,
      'isDesktop': windowWidth > brpTablet,
      'isTablet': (windowWidth <= brpTablet) && (windowWidth > brpMobile),
      'isMobile': windowWidth <= brpMobile,

    };

    function getCurrentBP() {
      for (var bp in mediaObj) {
        if (mediaObj[bp] == true) return bp;
      };
    };

    mediaObj.current = getCurrentBP();

    return mediaObj;
};

$(function() {
  var MediaQ = detect();
  var mediaTO = false;

  //initial bp trigger
  setTimeout(function() {
    $(window).trigger('mdbreakpoint', [false, MediaQ.current]);
  }, 0);

  var timeout;
  window.addEventListener('resize', event => {
    if (mediaTO) clearTimeout(mediaTO);
    mediaTO = setTimeout(function() {
      var newMediaQ = detect();
      if (MediaQ.current != newMediaQ.current) {
        $(window).trigger('mdbreakpoint', [MediaQ.current, newMediaQ.current]);
      }
      MediaQ = newMediaQ;
    }, 100);
  });
});

export default {
  detect: detect,
  breakpoints: breakpoints,
  dppx: res.dppx()
};



// WEBPACK FOOTER //
// ./mediaDetect.js